import {useLayoutEffect, useRef, useState} from "react";
import {MessageWithMetadata} from "../../../types";

const remToPx = (rem: number) => rem * 16;

/**
 * Sets CSS variables on a container element based on the last user message height
 * and estimated chat input height. Returns whether measurements are complete.
 */
export function useMessageHeightTracking(
    messages: MessageWithMetadata[] | undefined,
    chatInputEstimatedHeight: number
) {
    const containerRef = useRef<HTMLDivElement>(null);
    const lastUserMessageRef = useRef<HTMLDivElement>(null);
    const [heightsMeasured, setHeightsMeasured] = useState(false);

    const last = (messages?.length ?? 0) - 1;

    useLayoutEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        container.style.setProperty(
            "--chat-input-height-px",
            `${remToPx(chatInputEstimatedHeight)}px`
        );

        const userMessageExists = last > 0;
        const userMessageElement = lastUserMessageRef.current;

        if (userMessageExists && userMessageElement) {
            container.style.setProperty(
                "--last-user-message-height-px",
                `${userMessageElement.offsetHeight}px`
            );
        } else {
            container.style.setProperty("--last-user-message-height-px", `0px`);
        }
        setHeightsMeasured(true);
    }, [messages, chatInputEstimatedHeight, last]);

    return {containerRef, lastUserMessageRef, heightsMeasured};
}
